export default {
      id: "icon-dop-usage",
      viewBox: "0 0 147.24 123.79",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-dop",
      toString: function () {
        return this.url;
      }
    }